import React from 'react';
import { mathCalculators_Fr } from '../ConstantsMathCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices de mathematiques en ligne gratuites';
const DESCRIPTION = 'Retrouvez des calculatrices de mathematiques en francais pour les pourcentages, fractions, geometrie, statistiques, PGCD, PPCM et bien plus. Resultats immediats et explications simples.';
const KEYWORDS = 'calculatrice mathematiques, calculatrice pourcentage, calculatrice fractions, calculatrice geometrie, PGCD, PPCM, statistiques';
const OG_URL = 'https://do-calculate.com/fr/math-calculators/';

function MathCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Explorez la liste complete des outils de calcul mathematique: du niveau scolaire aux besoins techniques, tout est centralise sur cette page.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {mathCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default MathCalculatorsList;
